export const CIC_SAVE_REASON_MODAL_HEADER = 'CIC Reason Required';

export const CIC_SAVE_REASON_MODAL_DESCRIPTION =
  'The following changes triggered a Change in Circumstance. Enter a note to record the reason before saving.';

export const CIC_SAVE_REASON_NOTE_LABEL = 'Note';
